import React, { useId, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { auth, sendPasswordReset } from "../firebase.config";

function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [errorMessage, setErrorMessage] = useState("");
  const id = useId();

  return (
    <>
      <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
        <span className="login-element">
          <label
            className="nowrap"
            style={{ width: "auto" }}
            htmlFor={`username-${id}`}
          >
            Email:
          </label>
          <input
            type="text"
            id={`username-${id}`}
            placeholder="Email Address"
            value={email}
            required
            onChange={(e) => setEmail(e.target.value)}
          ></input>
        </span>
      </div>
      <p className="input-error">{errorMessage}</p>
      <button
        style={{ minWidth: "180px" }}
        variant="primary"
        onClick={async (e) => {
          e.preventDefault();
          sendPasswordReset(email);
          navigate("/");
        }}
      >
        Reset Password
      </button>
    </>
  );
}

export default ForgotPassword;
